export const news = [
  {
    id: 1,
    text: 'Lead advisor commented on Fidelity feedback',
    time: 'at 14:20'
  },
  { id: 2, text: 'Fidelity provided a feedback', time: 'at 14:20' },
  { id: 3, text: 'Praexo made a new suggestion', time: 'at 14:20' },
  {
    id: 4,
    text: 'Lead advisor answered to company’s comment on Truffle feedback',
    time: 'at 14:20'
  },
  { id: 5, text: 'Amundi suggest a call with management', time: 'at 14:20' }
];
